import React, { useEffect, useRef } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import '../@style/ara_hakkimizda.css';
import magazaImage from '../assets/images/magaza.jpg';

const AraHakkimizda = () => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();
  const textRef = useRef(null);
  const imageRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const container = containerRef.current;
      
      if (container) {
        const rect = container.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Görünür alana girdiğinde animasyonu başlat
        if (rect.top < windowHeight * 0.7) {
          textRef.current.style.transform = 'translateX(0)';
          imageRef.current.style.transform = 'translateX(0)';
          textRef.current.style.opacity = '1';
          imageRef.current.style.opacity = '1';
        } else {
          // Görünür alandan çıktığında kaybolma
          textRef.current.style.transform = 'translateX(-100px)';
          imageRef.current.style.transform = 'translateX(100px)';
          textRef.current.style.opacity = '0';
          imageRef.current.style.opacity = '0';
        }
      }
    };

    // Sayfa yüklendiğinde ilk animasyonu başlat
    setTimeout(() => {
      handleScroll();
    }, 100);

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`ara-hakkimizda-container ${isDarkMode ? 'dark-mode' : ''}`} ref={containerRef}>
      <div className="ara-hakkimizda-content">
        <div className="text-section" ref={textRef}>
          <h1 className="main-title">{t('ara_about.title')}</h1>
          <h2 className="subtitle">{t('ara_about.subtitle')}</h2>
          
          <div className="content-text">
            <p>
              {t('ara_about.content1')}
            </p>
            
            <p>
              {t('ara_about.content2')}
            </p>
            
            <p>
              {t('ara_about.content3')}
            </p>
            
            <p>
              {t('ara_about.content4')}
            </p>
          </div>
        </div>
        
        <div className="image-section" ref={imageRef}>
          <div className="image-container">
            <img src={magazaImage} alt={t('ara_about.image_alt')} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AraHakkimizda;
